export default __webpack_public_path__ + "static/media/monday.ed4cb2ae.jpg";